import React from 'react'
import PropTypes from 'prop-types'
import css from './styles/text-unknown-button.css'

const TextUnknownButton = ({ onClick }) => (
  <div className={css.wrapper}>
    <button
      className={css.button}
      onClick={onClick}
    >
      <span className={css.label}>TEXT UNKNOWN NUMBER</span>
    </button>
  </div>
)

TextUnknownButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default TextUnknownButton



// WEBPACK FOOTER //
// ./src/components/Messages/TextUnknownButton.js